// extracted by mini-css-extract-plugin
export default {"st0":"AddSectionIcon_st0__t9NLB","st1":"AddSectionIcon_st1__6eGww"};